import React, { Component } from 'react';
import { withRouter } from '../../boot/hooks/useRouter';
import moment from 'moment';

import { compose } from 'recompose';
import { withFirebase } from '../../components/Firebase';

import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { convertFromHTML } from 'draft-convert';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import NewEvent from './NewEvent';

import swal from 'sweetalert';
import I18n from '../../locales/i18n';
import Server from '../../services/Server';
import removeAccents from '../../services/removeAccents';

import {
	EVENT_IMAGES,
	ASSETS_SERVER_PATH,
	_VIDEO_SERVER_,
} from '../../config/defaults';

class NewEventContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			forbidden: false,
			step: 1,
			editorState: EditorState.createEmpty(),
			show_viewers: true,
			privacity: 'PUBLIC',
			record_viewer: false,
			login_methods: {
				facebook: true,
				twitter: true,
				google: true,
			},
			chat: true,
			qANDa: true,
			assets_progress: 100,
			name: '',
			organizer: '',
			url: '',
			maxDuration: 8,
			AGENDA: [],
			PANELISTS: [],
			SUPPORT_MATERIAL: [],
			IMAGE_BANNER: EVENT_IMAGES.BANNER,
			IMAGE_EVENT_AVATAR: EVENT_IMAGES.EVENT_AVATAR,
			IMAGE_ORGANIZER_AVATAR: EVENT_IMAGES.ORGANIZER_AVATAR,
			player_theme: 'dark',
			videoServer: _VIDEO_SERVER_,
		};

		this.forbidden = false;

		this.onChangeFiles = this.onChangeFiles.bind(this);
		this.onChangeStep = this.onChangeStep.bind(this);
		this.onEventData = this.onEventData.bind(this);

		this.onNameChange = this.onNameChange.bind(this);
		this.onOrganizerChange = this.onOrganizerChange.bind(this);

		this.onEventInformation = this.onEventInformation.bind(this);
		this.onEventAssets = this.onEventAssets.bind(this);
		this.onEventVisualStyle = this.onEventVisualStyle.bind(this);
		this.onChangeImage = this.onChangeImage.bind(this);
		this.onDeleteImage = this.onDeleteImage.bind(this);
		this.onSocialNetworks = this.onSocialNetworks.bind(this);

		this.onSelectButtonChange = this.onSelectButtonChange.bind(this);
		this.setValuesFromProps = this.setValuesFromProps.bind(this);

		this.onSetState = this.onSetState.bind(this);

		this.gmtSelect = React.createRef();

		this.formRefs = {
			WT_0: React.createRef(),
			WT_1: React.createRef(),
			WT_2: React.createRef(),
			WT_3: React.createRef(),
			WT_4: React.createRef(),
			WT_5: React.createRef(),
			StartDate: React.createRef(),
			//Duration: React.createRef(),
			short_description: React.createRef(),
			kind_of_event: React.createRef(),
			topic: React.createRef(),
			AssetDropZone_0: React.createRef(),
			AssetDropZone_1: React.createRef(),
			AssetDropZone_2: React.createRef(),
			facebook: React.createRef(),
			instagram: React.createRef(),
			twitter: React.createRef(),
			linkedin: React.createRef(),
			Hashtag: React.createRef(),
		};

		const userLang = navigator.language || navigator.userLanguage;

		this.language = localStorage.getItem('lang') || userLang.substring(0, 2);
	}

	componentDidMount() {
		const self = this;
		const _package = self.props.firebase.getDoc(
			'packages',
			this.props.currentUser.package_id
		);
		_package.get().then((doc) => {
			if (doc.exists) {
				const _data = doc.data();
				self.setState({
					maxDuration: _data.maxDuration || 8,
					videoServer: _data.videoServer || _VIDEO_SERVER_,
				});
			}
		});

		this.gmtSelect.current.value = parseInt(
			moment().format('Z').replace(':', ''),
			10
		);

		if (this.props.isEditing && this.props.event !== undefined) {
			const { event, docRef } = this.props;
			this.setValuesFromProps(event, docRef);
		} else {
			if (this.props.location) {
				if (this.props.location.state) {
					const { eventsLength, eventsLimit } = this.props.location.state;
					if (eventsLength >= eventsLimit) {
						this.forbidden = true;
						this.setState({ forbidden: true });
					}
				} else {
					this.forbidden = true;
					this.setState({ forbidden: true });
				}
			} else {
				this.forbidden = true;
				this.setState({ forbidden: true });
			}
		}
	}

	componentWillReceiveProps(ns) {
		if (this.props.isEditing) {
			if (this.props.event === undefined && ns.event !== undefined) {
				const { event, docRef } = ns;
				this.setValuesFromProps(event, docRef);
			}
		}
	}
	onSetState(data) {
		this.setState(data);
	}

	onChangeFiles(handler, files) {
		this.setState({ [handler]: files });
	}
	onChangeStep(e) {
		let newValue = this.state.step + 1;
		this.setState({ step: newValue });
	}
	onNextStep(e) {
		let newValue = this.state.step + 1;
		this.setState({ step: newValue });
	}
	onNameChange(e) {
		const newValue = e.currentTarget.value,
			url = removeAccents(this.state.organizer) + '/' + removeAccents(newValue);

		this.setState({ name: newValue, url: url });
	}
	onOrganizerChange(e) {
		const newValue = e.currentTarget.value,
			url = removeAccents(newValue) + '/' + removeAccents(this.state.name);

		this.setState({ organizer: newValue, url: url });
	}
	onEventData(e, onValidate) {
		//onValidate(true);

		const { name, startDate, gmt, organized } = e.target.elements;
		let duration = 0;

		try {
			duration = this.props.currentUser.packageDetails.maxDuration;
		} catch (error) {}

		if (name.value === '') {
			//Empty name
			emptyFields(name, I18n('NEW_EVENT', 'EVENT_NAME'));
			onValidate(false);
		} else {
			if (startDate.value === '') {
				emptyFields(startDate, I18n('NEW_EVENT', 'DATE_FROM'));
				onValidate(false);
			} else {
				if (duration === 0) {
					emptyFields(duration, I18n('NEW_EVENT', 'DATE_UNTIL'));
					onValidate(false);
				} else {
					if (organized.value === '') {
						emptyFields(organized, I18n('NEW_EVENT', 'ORGANIZED_BY'));
						onValidate(false);
					} else {
						const _startDate = moment(startDate.value, 'YYYY-MM-DD HH:mm'),
							_endDate = _startDate.add(duration, 'HOURS');

						if (_startDate.isBefore(moment())) {
							//Start must be minor than End
							swal('', I18n('ERRORS', 'START_DATE_CANT_BE_IN_PAST'), 'error');
						} else {
							//Save date
							this.props.onRequestLoading(true);

							const self = this,
								data = {
									ACTIVE: true,
									name: name.value,
									startDate: startDate.value,
									_startDate: moment(startDate.value).unix(),
									duration: duration,
									endDate: _endDate.format('YYYY-MM-DD HH:mm'),
									_endDate: _endDate.unix(),
									gmt: gmt.value,
									organized: organized.value,
									videoServer: this.state.videoServer,
									url: this.state.url,
								},
								collection = 'events';

							if (this.state.docRef === undefined) {
								this.props.firebase
									.getCollection('events', 'url', '==', this.state.url, {
										condition_field: 'ACTIVE',
										condition: '==',
										condition_value: true,
									})
									.then((response) => {
										if (response.size > 0) {
											swal(
												'Opps!',
												I18n('ERRORS', 'DUPLICATE_NAME'),
												'error'
											).then((value) => {
												name.focus();
												onValidate(false);
												self.props.onRequestLoading(false);
											});
										} else {
											data.CREATION_DATE = moment().format(
												'YYYY-MM-DDTHH:mm:SSZ'
											);
											data._CREATION_DATE = moment().unix();
											data.owner = self.props.currentUser.uid;
											data.owner_name = self.props.currentUser.displayName;
											data.owner_email = self.props.currentUser.email;
											data.countdown = true;

											self.props.firebase
												.add(collection, data)
												.then((obj) => {
													/*
                                            self.props.onRequestLoading(false);
                                            onValidate(true);
                                            */

													const _handleError = (id) => {
														self.props.firebase
															.deleteDoc('events', id)
															.then(() => {
																swal(
																	'Error',
																	'En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos',
																	'error'
																);
																onValidate(false);
																self.props.onRequestLoading(false);
															});
													};

													const _handleCreate = (_package) => {
														const _transcoder =
															_package !== undefined
																? _package.transcoder
																: false;

														const { currentUser = {} } = self.props,
															{ packageDetails = {} } = currentUser,
															{ videoServer = '1566626989_2ZWqtfdRrxCA' } =
																packageDetails;

														Server.events
															.create(
																videoServer,
																obj.id,
																data.url,
																_transcoder,
																duration,
																data.name
															)
															.then((live_stream_data) => {
																if (live_stream_data.data.status === 200) {
																	self.props.firebase
																		.updateDoc(obj, {
																			live_stream:
																				live_stream_data.data.live_stream,
																		})
																		.then(() => {
																			/*
                                                                    data.live_stream = live_stream_data.data.live_stream;
                                                                    self.props.onRequestLoading(false);
                                                                    onValidate(true);
                                                                    */
																			self.props.history.push(
																				`/event/${obj.id}/edit`
																			);
																		})
																		.catch((error) => {
																			console.error(error);
																			_handleError(obj.id);
																		});
																} else {
																	_handleError(obj.id);
																}
															})
															.catch(() => {
																_handleError(obj.id);
															});
													};

													try {
														if (self.props.currentUser.package_id) {
															self.props.firebase
																.getDoc(
																	'packages',
																	self.props.currentUser.package_id
																)
																.get()
																.then((doc) => {
																	if (doc.exists) {
																		_handleCreate(doc.data());
																	} else {
																		_handleCreate();
																	}
																});
														}
													} catch (e) {
														_handleCreate();
													}
													//});
												})
												.catch((error) => {
													swal('Opps!', error.message, 'error').then(
														(value) => {
															self.props.onRequestLoading(false);
														}
													);
												});
										}
									});
							} else {
								this.props.onRequestLoading(false);
								this.props.firebase
									.updateDoc(this.state.docRef, data)
									.then(() => {
										onValidate(true);
									})
									.catch((error) => {
										swal('Opps!', error.message, 'error').then((value) => {});
									});
							}
						}
					}
				}
			}
		}
	}
	onEventInformation(e, onValidate) {
		//onValidate(true);

		const {
				short_description,
				kind_of_event,
				show_viewers,
				privacity,
				auto_register = { value: false },
				record_viewer = { value: false },
				login_methods_google = { checked: true },
				login_methods_facebook = { checked: true },
				login_methods_twitter = { checked: true },
				login_methods_email = { checked: true },
				login_methods_code = { checked: true },
				chat,
				qANDa,
				topic,
			} = e.target.elements,
			long_description = {
				value: draftToHtml(
					convertToRaw(this.state.editorState.getCurrentContent())
				),
			};

		if (this.state.docRef !== undefined) {
			const login_methods = {
				code: login_methods_code.checked,
				email: login_methods_email.checked,
				facebook: login_methods_facebook.checked,
				twitter: login_methods_twitter.checked,
				google: login_methods_google.checked,
			};
			let flag_login_methods = false;
			for (let index in login_methods) {
				if (login_methods[index] === true) {
					flag_login_methods = true;
				}
			}

			if (flag_login_methods) {
				const self = this;
				self.props.onRequestLoading(true);

				this.props.firebase
					.updateDoc(this.state.docRef, {
						auto_register: auto_register.value === 'true',
						login_methods: login_methods,
						short_description: short_description.value,
						long_description: long_description.value,
						kind_of_event: kind_of_event.value,
						show_viewers: show_viewers.value === 'true',
						privacity: privacity.value,
						record_viewer: record_viewer.value,
						chat: chat.value,
						qANDa: qANDa.value,
						topic: topic.value,
					})
					.then((obj) => {
						self.props.onRequestLoading(false);
						/*if (privacity.value === "PRIVATE"){
                            self.props.trackEvent(self.state.docRef.id, "subscribers");
                        }*/

						onValidate(true);
					})
					.catch((error) => {
						self.props.onRequestLoading(false);

						swal('Opps!', error.message, 'error');
					});
			} else {
				swal(
					'Opps!',
					'Debes seleccionar al menos un método de inicio de sesión',
					'error'
				);
			}
		}
	}
	onEventAssets(e, onValidate) {
		//onValidate(true);

		this.props.onRequestLoading(true);

		const self = this,
			_arr = [
				{ label: 'AGENDA', files: this.state.AGENDA },
				{ label: 'PANELISTS', files: this.state.PANELISTS },
				{ label: 'SUPPORT_MATERIAL', files: this.state.SUPPORT_MATERIAL },
			],
			totalFiles =
				this.state.AGENDA.length +
				this.state.PANELISTS.length +
				this.state.SUPPORT_MATERIAL.length,
			ans = {
				AGENDA: [],
				PANELISTS: [],
				SUPPORT_MATERIAL: [],
			};

		let idx = 0,
			assets_progress = 0;

		const checkFinal = () => {
			idx++;
			if (idx === totalFiles) {
				this.props.firebase
					.updateDoc(this.state.docRef, ans)
					.then((obj) => {
						self.props.onRequestLoading(false);

						self.setState({ assets_progress: 100 });
						onValidate(true);
					})
					.catch((error) => {
						self.props.onRequestLoading(false);

						swal('Opps!', error.message, 'error');
					});
			} else {
				assets_progress = parseInt((idx * 100) / totalFiles, 10);
				self.setState({ assets_progress: assets_progress });
			}
		};

		_arr.forEach((panel) => {
			panel.files.forEach((file) => {
				if (file.name !== undefined) {
					let fd = new FormData();
					fd.append('data', file);
					Server.sendEventAsset(self.state.docRef.id, panel.label, fd)
						.then((response) => {
							if (response.status === 200) {
								ans[panel.label].push({
									file: file.name,
									path: response.data.path,
								});
								checkFinal();
							}
						})
						.catch((err) => {
							console.error('ERROR', err);
							swal(
								'Opps!',
								`En este momento no podemos subir ${file.name}, vuelve a la página de eventos para editar esta sección o intentalo nuevamente mas tarde`,
								'error'
							).then(() => {
								checkFinal();
							});
						});
				} else {
					ans[panel.label].push(file);
					checkFinal();
				}
			});
		});

		if (totalFiles === 0) {
			self.props.onRequestLoading(false);

			onValidate(true);
		}
	}
	onEventVisualStyle(e, onValidate) {
		//onValidate(true);

		this.props.onRequestLoading(true);

		const { player_theme } = this.state;

		if (this.state.docRef !== undefined) {
			const self = this;
			self.props.onRequestLoading(true);

			this.props.firebase
				.updateDoc(this.state.docRef, {
					player_theme: player_theme,
				})
				.then((obj) => {
					self.props.onRequestLoading(false);

					onValidate(true);
				})
				.catch((error) => {
					self.props.onRequestLoading(false);
					swal('Opps!', error.message, 'error');
				});
		}
	}
	onChangeImage(type, extension, path) {
		const self = this,
			newValue = { ['IMAGE_' + type]: extension },
			d = new Date(),
			newImage = { ['IMAGE_' + type]: path + '?t=' + d.getTime() };
		this.props.onRequestLoading(true);

		this.props.firebase
			.updateDoc(this.state.docRef, newValue)
			.then((obj) => {
				self.setState(newImage, () => {
					self.props.onRequestLoading(false);
				});
			})
			.catch((error) => {
				console.error(error);
				self.props.onRequestLoading(false);
				swal('Opps!', error.message, 'error');
			});
	}
	onDeleteImage(type) {
		const self = this;
		this.props.firebase
			.deleteField(this.state.docRef, ['IMAGE_' + type])
			.then(() => {
				const newValue = { ['IMAGE_' + type]: EVENT_IMAGES[type] };
				self.setState(newValue);
			});
	}
	onSocialNetworks(e, onValidate) {
		//onValidate(true);

		const { facebook, instagram, twitter, linkedin, Hashtag } =
			e.target.elements;

		this.props.onRequestLoading(true);

		if (this.state.docRef !== undefined) {
			const self = this;
			self.props.onRequestLoading(true);
			this.props.firebase
				.updateDoc(this.state.docRef, {
					facebook: facebook.value,
					instagram: instagram.value,
					twitter: twitter.value,
					linkedin: linkedin.value,
					Hashtag: Hashtag.value,
				})
				.then((obj) => {
					self.props.onRequestLoading(false);
					onValidate(true);
					self.props.history.push(
						'/event/' + this.state.docRef.id + '/settings'
					);
				})
				.catch((error) => {
					self.props.onRequestLoading(false);
					swal('Opps!', error.message, 'error');
				});
		}
	}

	onSelectButtonChange(newValue, field) {
		this.setState({ [field]: newValue });
	}
	setValuesFromProps(event, docRef) {
		const self = this;

		this.canNotEdit = false;
		const { sa = '' } = this.props.currentUser;

		if (sa !== this.props.currentUser.uid) {
			if (event.endDate.isBefore(moment())) {
				this.canNotEdit = true;
			}
		}

		let {
			IMAGE_BANNER = EVENT_IMAGES.BANNER,
			IMAGE_EVENT_AVATAR = EVENT_IMAGES.EVENT_AVATAR,
			IMAGE_ORGANIZER_AVATAR = EVENT_IMAGES.ORGANIZER_AVATAR,
		} = event;

		if (IMAGE_BANNER !== EVENT_IMAGES.BANNER) {
			IMAGE_BANNER =
				ASSETS_SERVER_PATH +
				'events/' +
				event.id +
				'/IMAGE/BANNER' +
				IMAGE_BANNER;
		}
		if (IMAGE_EVENT_AVATAR !== EVENT_IMAGES.EVENT_AVATAR) {
			IMAGE_EVENT_AVATAR =
				ASSETS_SERVER_PATH +
				'events/' +
				event.id +
				'/IMAGE/EVENT_AVATAR' +
				IMAGE_EVENT_AVATAR;
		}
		if (IMAGE_ORGANIZER_AVATAR !== EVENT_IMAGES.ORGANIZER_AVATAR) {
			IMAGE_ORGANIZER_AVATAR =
				ASSETS_SERVER_PATH +
				'events/' +
				event.id +
				'/IMAGE/ORGANIZER_AVATAR' +
				IMAGE_ORGANIZER_AVATAR;
		}

		let id_last_tab = 1;

		this.setState({
			docRef: docRef,
			name: event.name,
			organizer: event.organized,
			url: event.url,
			show_viewers:
				event.show_viewers !== undefined ? event.show_viewers : true,
			privacity: event.privacity || 'PUBLIC',
			auto_register: event.auto_register,
			record_viewer: event.record_viewer === 'true',
			login_methods: event.login_methods,
			chat: event.chat === 'true' || event.chat === undefined,
			qANDa: event.qANDa === 'true' || event.qANDa === undefined,
			editorState: EditorState.createWithContent(
				convertFromHTML(event.long_description || '')
			),
			AGENDA: event.AGENDA || [],
			PANELISTS: event.PANELISTS || [],
			SUPPORT_MATERIAL: event.SUPPORT_MATERIAL || [],
			IMAGE_BANNER: IMAGE_BANNER,
			IMAGE_EVENT_AVATAR: IMAGE_EVENT_AVATAR,
			IMAGE_ORGANIZER_AVATAR: IMAGE_ORGANIZER_AVATAR,
			player_theme: event.player_theme || 'dark',
		});

		this.gmtSelect.current.value = event.gmt;

		this.formRefs.StartDate.current.set(event.startDate);
		//this.formRefs.Duration.current.handleChangeHorizontal(parseInt(event.duration, 10));

		this.formRefs.WT_0.current.complete();

		if (event.short_description !== undefined) {
			id_last_tab++;
			this.formRefs.WT_1.current.complete();
			this.formRefs.short_description.current.value = event.short_description;
			this.formRefs.kind_of_event.current.value = event.kind_of_event;
			this.formRefs.topic.current.value = event.topic;
		}

		if (event.AGENDA !== undefined) {
			id_last_tab++;
			this.formRefs.WT_2.current.complete();
			const _file_categories = [
					event.AGENDA,
					event.PANELISTS,
					event.SUPPORT_MATERIAL,
				],
				_files = [[], [], []];

			_file_categories.forEach((category, idx) => {
				category.forEach((files, idj) => {
					_files[idx].push({
						path: files.file,
						serverPath: files.path,
						loaded: true,
						size: 0,
					});
				});
			});

			_files.forEach((category, index) => {
				self.formRefs[`AssetDropZone_${index}`].current.setFiles(category);
			});
		}

		if (event.IMAGE_BANNER !== undefined) {
			id_last_tab++;
			this.formRefs.WT_3.current.complete();
		}

		if (event.player_theme !== undefined) {
			id_last_tab++;
			this.formRefs.WT_4.current.complete();
		}

		if (event.facebook !== undefined) {
			id_last_tab++;
			this.formRefs.WT_5.current.complete();
			this.formRefs.facebook.current.value = event.facebook;
			this.formRefs.instagram.current.value = event.instagram;
			this.formRefs.twitter.current.value = event.twitter;
			this.formRefs.linkedin.current.value = event.linkedin;
			this.formRefs.Hashtag.current.value = event.Hashtag;
		}

		if (id_last_tab < 6) {
			this.formRefs[`WT_${id_last_tab}`].current.enable();
		}
		/*} else{
            swal("", I18n("ERRORS", "CANT_BE_EDIT"), "error")
                .then(() => {
                    this.props.history.push("./resume");
                })
                .catch(() => { });
        }*/
	}
	render() {
		if (this.forbidden) {
			setTimeout(() => {
				this.props.history.push('../events');
			}, 3500);
			return (
				<div className="cnt-no-setup-event">
					<span>
						<i className="fas fa-hand-paper"></i>
						<i className="fas fa-spinner fa-spin"></i>
						<i className="fas fa-helicopter"></i>
					</span>
				</div>
			);
		}

		return (
			<NewEvent
				canNotEdit={this.canNotEdit}
				formRefs={this.formRefs}
				onSetState={this.onSetState}
				onEventData={this.onEventData}
				onNameChange={this.onNameChange}
				gmtSelect={this.gmtSelect}
				onOrganizerChange={this.onOrganizerChange}
				onEventInformation={this.onEventInformation}
				language={this.language}
				onSelectButtonChange={this.onSelectButtonChange}
				onEventAssets={this.onEventAssets}
				onChangeFiles={this.onChangeFiles}
				onChangeImage={this.onChangeImage}
				onDeleteImage={this.onDeleteImage}
				onEventVisualStyle={this.onEventVisualStyle}
				onSocialNetworks={this.onSocialNetworks}
				{...this.props}
				{...this.state}
			/>
		);
	}
}

export default compose(withRouter, withFirebase)(NewEventContainer);

const emptyFields = (control, controlName) => {
	swal('', `${controlName} ${I18n('ERRORS', 'CANT_BE_EMPTY')}`, 'error')
		.then(() => {
			control.focus();
		})
		.catch(() => {});
};
